module.exports = __webpack_public_path__ + "static/media/pt.31043725.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/languages/pt.svg
// module id = 1865
// module chunks = 0